import React from 'react'

const CardReaderDisconnected = () => {
  const styles = {
    display: 'block',
    flexGrow: 0,
    flexShrink: 0,
  }

  return (
    <svg style={styles} width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Badge-/-Card-/-Disconnected" transform="translate(-14.000000, -11.000000)">
          <g id="card-reader-unavailable" transform="translate(16.000000, 13.000000)">
            <path d="M6.41421356,1 L18,1 C19.11,1 20,1.89 20,3 L20,14.5857864 L18,12.5857864 L18,9 L14.4142136,9 L10.4142136,5 L18,5 L18,3 L8.41421356,3 L6.41421356,1 Z M3.58578644,1 L5.58578644,3 L2,3 L2,5 L7.58578644,5 L11.5857864,9 L2,9 L2,15 L17.5857864,15 L19.1938551,16.6080687 C18.861334,16.8546104 18.4486365,17 18,17 L2,17 C0.89,17 0,16.11 0,15 L0.01,3 C0.01,1.89 0.89,1 2,1 L3.58578644,1 Z" id="Combined-Shape" fill="#000000" fillRule="nonzero"></path>
            <path d="M0,0 L18,18" id="Line-3" stroke="#000000" strokeWidth="2" strokeLinecap="square"></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default CardReaderDisconnected
